import React from 'react';
import { ListGroup, Button, Row, Col, ButtonGroup } from 'react-bootstrap';
import { FaFolder, FaFile, FaDownload, FaShareAlt, FaTrash } from 'react-icons/fa';

const FileList = ({ 
  folders, 
  files, 
  onFolderClick, 
  onDownloadClick, 
  onShareClick,
  onDeleteClick,
  isAdmin = false
}) => {
  return (
    <div className="file-list">
      <div className="file-list-header">
        <Row>
          <Col md={6}>Name</Col>
          <Col md={3}>Size</Col>
          <Col md={3}>Actions</Col>
        </Row>
      </div>
      
      <ListGroup variant="flush">
        {folders.length === 0 && files.length === 0 && (
          <div className="text-center py-4 text-muted">
            This folder is empty
          </div>
        )}
        
        {folders.map((folder) => (
          <ListGroup.Item key={folder.path} className="file-list-item">
            <Row>
              <Col md={6} onClick={() => onFolderClick(folder.path)} style={{ cursor: 'pointer' }}>
                <FaFolder className="me-2 text-warning" />
                {folder.name}
              </Col>
              <Col md={3}>-</Col>
              <Col md={3}></Col>
            </Row>
          </ListGroup.Item>
        ))}
        
        {files.map((file) => (
          <ListGroup.Item key={file.path} className="file-list-item">
            <Row>
              <Col md={6}>
                <FaFile className="me-2 text-primary" />
                {file.name}
              </Col>
              <Col md={3}>
                {formatSize(file.size)}
              </Col>
              <Col md={3}>
                <ButtonGroup>
                  <Button 
                    variant="outline-primary" 
                    size="sm" 
                    onClick={() => onDownloadClick(file.path)}
                  >
                    <FaDownload /> Download
                  </Button>
                  <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={() => onShareClick(file.path)}
                  >
                    <FaShareAlt /> Share
                  </Button>
                  {isAdmin && onDeleteClick && (
                    <Button 
                      variant="outline-danger" 
                      size="sm"
                      onClick={() => onDeleteClick(file.path)}
                    >
                      <FaTrash /> Delete
                    </Button>
                  )}
                </ButtonGroup>
              </Col>
            </Row>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

// Helper function to format file size
const formatSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export default FileList;
